import React from 'react';
import { VoidReturn } from '../../../Utils/PageUtils';
import {
    DialogState,
    MainViewWorkflow,
    PageState,
    TransitionAction,
} from './MainViewModel';

export interface IMainViewContext {
    pageState: PageState;
    dialogState: DialogState;
    workflowType: MainViewWorkflow;
    doTransition: (action: TransitionAction) => VoidReturn;
    backButtonTransition: (
        action: (() => VoidReturn) | undefined
    ) => VoidReturn;
}

export const MainViewContext = React.createContext({} as IMainViewContext);
